import React, { useEffect, useState } from "react";
import "../App.css";
import "../sections/Home.css";
import SectionNav from "./SectionNav";

const Home = () => {
  const [activeSection, setActiveSection] = useState("");

  useEffect(() => {
    const sections = document.querySelectorAll("section");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveSection(entry.target.id);
          }
        });
      },
      { threshold: 0.6 }
    );

    sections.forEach((section) => observer.observe(section));

    return () => sections.forEach((section) => observer.unobserve(section));
  }, []);

  return (
    <section id="home" className="home-section">
      <div className="content">
        <h1>Opeyemi Ogeroju</h1>
        
        <h2>Software Tester</h2>
        <p>
          I am an ISTQB-certified Software Test Engineer skilled in manual and
          automated testing across web and mobile platforms. I use tools like
          Selenium and Appium within Agile teams to ensure quality and
          efficiency.
          <br />
          <br />I focus on improving test coverage, reducing defects, and
          mentoring others through practical, hands-on training in software
          testing.
        </p>

        <div className="contact-info">
          <span>
            <i className="fas fa-envelope"></i>{" "}
            <a
              href="mailto:OpeyemiRabiat@gmail.com"
              style={{ color: "inherit", textDecoration: "none" }}
            >
              OpeyemiRabiat@gmail.com
            </a>
          </span>
          <span>
            <i className="fas fa-phone-alt"></i>{" "}
            <a
              href="tel:+447867279428"
              style={{ color: "inherit", textDecoration: "none" }}
            >
              +44-078-6727-9428
            </a>
          </span>
          <span>
            <i className="fas fa-map-marker-alt"></i> United Kingdom
          </span>
        </div>

        <div className="social-links">
          <a
            href="https://linkedin.com/in/opeyemi-ogeroju"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-linkedin"></i>
          </a>
          <a
            href="https://github.com/Rabiart"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-github"></i>
          </a>
          <a
            href="https://github.com/Rabiart"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-stack-overflow"></i>
          </a>
        </div>

        <a
          href="https://drive.google.com/file/d/1hJ8TZqu9BhI1C2LacqYnskU3jdpf06yh/view?usp=sharing"
          target="_blank"
          rel="noopener noreferrer"
          className="cta-button"
        >
          View My Resume
        </a>
        {/* <div className="scroll-down">
          <a href="#contact">More about me ↓</a>
        </div> */}

        {/* Vertical navigation for desktop */}
        <SectionNav activeSection={activeSection} />
      </div>
    </section>
  );
};
export default Home;
